/* ebbe — innehållsförteckningen i guidemallen.

   Markerar det avsnitt läsaren befinner sig i. Rubrikerna får sina id:n i
   sections/main-article-guide.liquid, som också skriver ut länkarna, så
   den här filen letar aldrig upp rubriker på egen hand.

   IntersectionObserver med en rootMargin som gör om viewporten till ett
   smalt band strax under headern: det avsnitt vars rubrik senast passerat
   bandet är det aktiva. Ett vanligt scroll-läge hade krävt en lyssnare på
   varje scroll-event.

   Mobilvyns lista ligger i en <details> och sköter sig själv. */

(function () {
  const toc = document.querySelector('[data-article-toc]');
  if (!toc) return;

  const links = Array.from(toc.querySelectorAll('[data-article-toc-link]'));
  if (links.length === 0) return;

  const headings = links
    .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
    .filter(Boolean);
  if (headings.length === 0) return;

  const setActive = (id) => {
    links.forEach((link) => {
      const isActive = decodeURIComponent(link.hash.slice(1)) === id;
      link.parentElement.classList.toggle('article-guide__toc-item--active', isActive);
    });
  };

  setActive(headings[0].id);

  const headerHeight = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
    return parseInt(value, 10) || 0;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    },
    {
      // Bandet ligger strax under headern och är 40 % av fönstret högt.
      rootMargin: `-${headerHeight() + 80}px 0px -60% 0px`,
      threshold: 0,
    }
  );

  headings.forEach((heading) => observer.observe(heading));
})();
